import React from 'react';
import { Route, Switch } from 'react-router-dom';
import P, { InferProps } from 'prop-types';
import StoriesList from './stories-list';

function Stories({ match }: InferProps<typeof Stories.propTypes>) {
  return (
    <Switch>
      <Route exact path={`${match.url}/:abbrv`} component={StoriesList} />
    </Switch>
  );
}

Stories.propTypes = {
  match: P.shape({
    url: P.string.isRequired,
  }).isRequired,
};

export default Stories;
